import { z } from 'zod';
/**
 * Espejo Zod de los enums de Prisma. Fuente de verdad: `apps/api/prisma/schema.prisma`.
 *
 * Viven acá porque los usan back y front (filtros de listado, badges de estado, selects).
 * Si cambia el schema, se cambian estos también — no hay generación automática a propósito:
 * un enum del dominio que cambia es una decisión, no un detalle de build.
 */
/**
 * Rol del usuario dentro de su medio. Qué puede hacer cada uno está en `permisos.ts`, no acá:
 * el enum es la identidad, la matriz es la regla, y el orden de esta lista es el de Postgres.
 */
export const UserRoleSchema = z.enum(['ADMIN', 'EDITOR', 'WRITER']);
/** Cómo se nombra cada rol en el panel. El enum viaja en inglés, la pantalla habla español. */
export const USER_ROLE_LABEL = {
    ADMIN: 'Administrador',
    EDITOR: 'Editor',
    WRITER: 'Escritor',
};
export const ArticleStatusSchema = z.enum(['DRAFT', 'PUBLISHED', 'ARCHIVED']);
export const ModuleKeySchema = z.enum([
    'ADVERTISING',
    'ANALYTICS',
    'NEWSLETTER',
    'MULTIMEDIA',
    'EDITORIAL_WORKFLOW',
]);
/**
 * El tenant no tiene ese módulo habilitado. El panel no debería llegar a verlo (un módulo
 * apagado no muestra su ítem ni registra su ruta), pero la API igual lo rechaza: el token
 * sirve para todo el panel, y el gate del front no es una defensa.
 */
export const MODULE_ERROR_CODES = {
    deshabilitado: 'MODULO_DESHABILITADO',
};
export const AdPlacementSchema = z.enum(['HEADER', 'SIDEBAR', 'IN_FEED', 'IN_ARTICLE', 'FOOTER']);
export const AdTypeSchema = z.enum(['IMAGE', 'HTML']);
/**
 * Cómo se dibuja un bloque de categoría en la página principal: tira de tarjetas con foto, lista con
 * miniatura, o cuadrícula de tres por línea. Lo elige el editor; `null` en la base = lo elige la
 * rotación automática del sitio, en la que **la cuadrícula no participa**: es una disposición que hay
 * que pedir a mano (ver `rotacion.ts` en el sitio).
 * Cuántas notas muestra cada una de una vez, y qué cantidades son válidas, está en `plantillas.ts`.
 */
export const PlantillaBloqueSchema = z.enum(['TIRA', 'LISTA', 'CUADRICULA']);
